import React, { Component } from "react";
import { Typography, Grid } from "@material-ui/core";
import { Button, FormControl, Card } from "react-bootstrap";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { GetData, PostData, DeleteData, PutData } from "../../api/service";
import Snack from "../Snackbar/Snack";
import FileUpload from "../AddNew/FileUpload";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const PHOTO_UPLOAD_TYPE = "FORMER_VOLUNTEER_PHOTO";

// Column order matches the required report heads (excluding Sl. No., which is
// derived per-year, and the Actions column which is admin-only / not exported).
const EXPORT_HEADS = [
  "Sl. No.",
  "Name",
  "Rank",
  "Volunteer Enrolment Number",
  "GU Roll Number",
  "Date of Enrolling",
  "Date of Exit / Completion",
  "Special Camp Dates (From - To)",
  "Contact Number",
  "Email ID",
  "Photo",
];

const EMPTY_FORM = {
  id: "",
  edit: false,
  year: "",
  order_no: 1,
  name: "",
  rank: "",
  volunteer_enrolment_number: "",
  gu_roll_number: "",
  date_of_enrolling: "",
  date_of_exit: "",
  special_camp_from: "",
  special_camp_to: "",
  phone: "",
  email: "",
  photo: [],
};

class FormerVolunteerManager extends Component {
  state = {
    ...EMPTY_FORM,
    data: [],
    isDataLoaded: false,
    message: "",
    open: false,
    loadFile: true,
  };

  componentDidMount() {
    this.__loadList();
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  __loadList = () => {
    this.setState({ isDataLoaded: false });
    GetData(`/getformervolunteers`)
      .then((resp) => {
        this.setState({
          data: Array.isArray(resp) ? resp : [],
          isDataLoaded: true,
        });
      })
      .catch(() => {
        this.setState({ data: [], isDataLoaded: true });
      });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const d = {
      id: this.state.id,
      year: this.state.year,
      order_no: this.state.order_no,
      name: this.state.name,
      rank: this.state.rank,
      volunteer_enrolment_number: this.state.volunteer_enrolment_number,
      gu_roll_number: this.state.gu_roll_number,
      date_of_enrolling: this.state.date_of_enrolling,
      date_of_exit: this.state.date_of_exit,
      special_camp_from: this.state.special_camp_from,
      special_camp_to: this.state.special_camp_to,
      phone: this.state.phone,
      email: this.state.email,
      photo: this.state.photo,
    };

    if (this.state.edit) {
      PutData(
        `/${this.props.apikey}/${this.state.id}/editformervolunteer`,
        d
      ).then((resp) => {
        this.setState({ message: resp, open: true }, () => this.__loadList());
        this.cancelEdit();
      });
    } else {
      PostData(`/${this.props.apikey}/createformervolunteer`, d).then(
        (resp) => {
          this.setState({ message: resp, open: true }, () => this.__loadList());
          this.cancelEdit();
        }
      );
    }
  };

  onDeleteClick = (el) => {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete this volunteer?",
      buttons: [
        { label: "Yes", onClick: this.onDeleteConfirm.bind(this, el.id) },
        { label: "No" },
      ],
    });
  };

  onDeleteConfirm = (id) => {
    DeleteData(`/${this.props.apikey}/${id}/deleteformervolunteer`).then(
      (resp) => {
        this.setState({ message: resp, open: true }, () => this.__loadList());
      }
    );
  };

  onEditClick = (el) => {
    this.setState(
      {
        id: el.id,
        year: el.year || "",
        order_no: el.order_no || 1,
        name: el.name || "",
        rank: el.rank || "",
        volunteer_enrolment_number: el.volunteer_enrolment_number || "",
        gu_roll_number: el.gu_roll_number || "",
        date_of_enrolling: el.date_of_enrolling || "",
        date_of_exit: el.date_of_exit || "",
        special_camp_from: el.special_camp_from || "",
        special_camp_to: el.special_camp_to || "",
        phone: el.phone || "",
        email: el.email || "",
        photo: Array.isArray(el.photo) ? el.photo : [],
        edit: true,
        loadFile: false,
      },
      () => this.setState({ loadFile: true })
    );
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  cancelEdit = () => {
    this.setState({ ...EMPTY_FORM, loadFile: false }, () =>
      this.setState({ loadFile: true })
    );
  };

  // Group the flat list into { year: [rows...] }, preserving the backend order
  // (year DESC, order_no ASC).
  __groupByYear = () => {
    const groups = {};
    const order = [];
    (this.state.data || []).forEach((el) => {
      const y = el.year || "Unspecified";
      if (!groups[y]) {
        groups[y] = [];
        order.push(y);
      }
      groups[y].push(el);
    });
    return order.map((y) => ({ year: y, rows: groups[y] }));
  };

  __photoUrl = (el) => {
    if (Array.isArray(el.photo) && el.photo.length > 0) {
      return el.photo[0].url || "";
    }
    return "";
  };

  __specialCamp = (el) => {
    const from = el.special_camp_from || "";
    const to = el.special_camp_to || "";
    if (!from && !to) return "";
    return `${from}${from && to ? " - " : ""}${to}`;
  };

  render() {
    const groups = this.__groupByYear();

    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            message={this.state.message}
            handleClose={() => this.setState({ open: false, message: "" })}
          />
        ) : null}

        <form onSubmit={this.onSubmit}>
          <Typography variant="h6" gutterBottom>
            {this.props.title || "Former Volunteers"}
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            Records are grouped year-wise in the tables below. Each year can be
            downloaded as an Excel file.
          </Typography>

          <Card>
            <Card.Body>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={2} lg={2}>
                  <label>Year *</label>
                  <FormControl
                    as="input"
                    name="year"
                    required
                    onChange={this.onChange}
                    value={this.state.year}
                    placeholder="e.g. 2023-24"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={1} lg={1}>
                  <label>Sl. No.</label>
                  <FormControl
                    as="input"
                    type="number"
                    min={1}
                    name="order_no"
                    onChange={this.onChange}
                    value={this.state.order_no}
                    placeholder="Sl. No."
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={5} lg={5}>
                  <label>Name *</label>
                  <FormControl
                    as="input"
                    name="name"
                    required
                    onChange={this.onChange}
                    value={this.state.name}
                    placeholder="Name"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <label>Rank</label>
                  <FormControl
                    as="input"
                    name="rank"
                    onChange={this.onChange}
                    value={this.state.rank}
                    placeholder="Rank"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <label>Volunteer Enrolment Number</label>
                  <FormControl
                    as="input"
                    name="volunteer_enrolment_number"
                    onChange={this.onChange}
                    value={this.state.volunteer_enrolment_number}
                    placeholder="Volunteer Enrolment Number"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <label>GU Roll Number</label>
                  <FormControl
                    as="input"
                    name="gu_roll_number"
                    onChange={this.onChange}
                    value={this.state.gu_roll_number}
                    placeholder="GU Roll Number"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <label>Date of Enrolling</label>
                  <FormControl
                    as="input"
                    type="date"
                    name="date_of_enrolling"
                    onChange={this.onChange}
                    value={this.state.date_of_enrolling}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <label>Date of Exit / Completion</label>
                  <FormControl
                    as="input"
                    type="date"
                    name="date_of_exit"
                    onChange={this.onChange}
                    value={this.state.date_of_exit}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={2} lg={2}>
                  <label>Special Camp From</label>
                  <FormControl
                    as="input"
                    type="date"
                    name="special_camp_from"
                    onChange={this.onChange}
                    value={this.state.special_camp_from}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={2} lg={2}>
                  <label>Special Camp To</label>
                  <FormControl
                    as="input"
                    type="date"
                    name="special_camp_to"
                    onChange={this.onChange}
                    value={this.state.special_camp_to}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <label>Contact Number</label>
                  <FormControl
                    as="input"
                    name="phone"
                    onChange={this.onChange}
                    value={this.state.phone}
                    placeholder="Contact Number"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <label>Email ID</label>
                  <FormControl
                    as="input"
                    name="email"
                    onChange={this.onChange}
                    value={this.state.email}
                    placeholder="Email ID"
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <label>Photo</label>
                  {this.state.loadFile ? (
                    <FileUpload
                      dp={this.state.photo}
                      type={PHOTO_UPLOAD_TYPE}
                      setDp={this.handleChange.bind(this, "photo")}
                    />
                  ) : null}
                </Grid>
              </Grid>

              {this.state.edit ? (
                <div align="right">
                  <Button size="sm" variant="danger" type="submit">
                    Update
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    variant="secondary"
                    type="button"
                    onClick={this.cancelEdit}
                  >
                    Cancel
                  </Button>
                </div>
              ) : (
                <div align="right">
                  <Button size="sm" variant="info" type="submit">
                    Submit
                  </Button>
                </div>
              )}
            </Card.Body>
          </Card>
        </form>

        <br />

        {!this.state.isDataLoaded ? (
          <Typography>Loading . . .</Typography>
        ) : groups.length === 0 ? (
          <Card>
            <Card.Body>
              <Typography>No former volunteers added yet.</Typography>
            </Card.Body>
          </Card>
        ) : (
          groups.map(({ year, rows }) => (
            <Card key={year} style={{ marginBottom: 20 }}>
              <Card.Body>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <Typography variant="h6">Year: {year}</Typography>
                  <ReactHTMLTableToExcel
                    id={`dl-fv-${year}`}
                    className="btn btn-sm btn-success"
                    table={`fvexport-${year}`}
                    filename={`Former_Volunteers_${year}`}
                    sheet={`${year}`}
                    buttonText="Download Excel"
                  />
                </div>

                {/* On-screen admin table (with photo thumbnails + actions) */}
                <div style={{ overflowX: "auto" }}>
                  <table className="table table-sm table-bordered table-striped">
                    <thead>
                      <tr>
                        {EXPORT_HEADS.map((h) => (
                          <th key={h}>{h}</th>
                        ))}
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((el, index) => (
                        <tr key={el.id}>
                          <td>{el.order_no || index + 1}</td>
                          <td>{el.name}</td>
                          <td>{el.rank}</td>
                          <td>{el.volunteer_enrolment_number}</td>
                          <td>{el.gu_roll_number}</td>
                          <td>{el.date_of_enrolling}</td>
                          <td>{el.date_of_exit}</td>
                          <td>{this.__specialCamp(el)}</td>
                          <td>{el.phone}</td>
                          <td>{el.email}</td>
                          <td>
                            {this.__photoUrl(el) ? (
                              <img
                                src={this.__photoUrl(el)}
                                alt={el.name}
                                style={{ width: 45 }}
                              />
                            ) : null}
                          </td>
                          <td>
                            <Edit onClick={this.onEditClick.bind(this, el)} />
                          </td>
                          <td>
                            <Delete
                              onClick={this.onDeleteClick.bind(this, el)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Hidden, data-only table used purely as the Excel export source.
                    Photo is exported as a URL so the value is usable in Excel. */}
                <table
                  id={`fvexport-${year}`}
                  style={{ display: "none" }}
                >
                  <thead>
                    <tr>
                      {EXPORT_HEADS.map((h) => (
                        <th key={h}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((el, index) => (
                      <tr key={el.id}>
                        <td>{el.order_no || index + 1}</td>
                        <td>{el.name}</td>
                        <td>{el.rank}</td>
                        <td>{el.volunteer_enrolment_number}</td>
                        <td>{el.gu_roll_number}</td>
                        <td>{el.date_of_enrolling}</td>
                        <td>{el.date_of_exit}</td>
                        <td>{this.__specialCamp(el)}</td>
                        <td>{el.phone}</td>
                        <td>{el.email}</td>
                        <td>{this.__photoUrl(el)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Card.Body>
            </Card>
          ))
        )}
      </div>
    );
  }
}

export default FormerVolunteerManager;
